<template>
  <tile class="opc-ppm">
    <foldable v-model="isExpanded" :arrow="hasSelectedPlan" :edit="hasSelectedPlan" :title="title">
      <div slot="head">
        <div class="flex-container header-container">
          <img class="opc-ppm__logo right-cel" :src="IconZM" alt="Zoom One" />
          <div class="left-cel">
            <h1 class="opc-ppm__name">
              {{ title }}
              <span class="beta-icon">{{ $t('billing.common.beta') }}</span>
            </h1>
            <div class="flex-container">
              <span class="opc-ppm__info" v-if="selectedPlan">{{ $t('billing.zone_ppm.bill_info', { amount: $money(selectedPlan.amount), extensionTime: ppm_meeting_hours }) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="opc-ppm__body flex-container">
        <div class="opc-ppm__body-item">
          <img class="opc-ppm__body-item-icon" :src="IconStopwatch" alt="">
          <div>
            <p class="opc-ppm__body-item-title">
              {{ $t('billing.zone_ppm.comments.instant_extension') }}
            </p>
            <p class="opc-ppm__body-item-text">
              {{ $t('billing.zone_ppm.comments.instant_extension_desc') }}
            </p>
          </div>
        </div>
        <div class="opc-ppm__body-item">
          <img class="opc-ppm__body-item-icon" :src="IconCheckmark" alt="">
          <div>
            <p class="opc-ppm__body-item-title">
              {{ $t('billing.zone_ppm.comments.one_time_purchase') }}
            </p>
            <p class="opc-ppm__body-item-text">
              {{ $t('billing.zone_ppm.comments.one_time_purchase_desc') }} 
            </p>
          </div>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import plansMixin from '@/plans/mx/plan';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import IconZM from '@/assets/plans/icon_ZM.svg';
import IconCheckmark from '@/assets/plans/Checkmark.svg';
import IconStopwatch from '@/assets/plans/Stopwatch.svg';
import { mapGetters } from 'vuex';
import { $info } from '@/components/service/config-banner';
import { $desc } from '@/components/service/config-desc';
import { pageConfig } from '@/common/service/page-config';

export default {
  components: {
    Foldable,
    Tile,
  },
  mixins: [plansMixin],
  data() {
    return {
      isExpanded: true,
      title: this.$t('billing.zone_ppm.title'),
      hasSelectedPlan: false,
      IconZM,
      IconStopwatch,
      IconCheckmark,
      ppm_meeting_hours: pageConfig.ppm_meeting_hours || 24,
      form: {
        license: 1,
        billing_cycle: BILLING_CYCLE.MONTHLY,
      },
    };
  },
  mounted() {
    $info({ message: this.$t('billing.zone_ppm.banner_tips') });
    $desc(this.descRender());
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZONE_PPM);
    },
  },
  methods: {
    descRender() {
      return <p>{ this.$t('billing.zone_ppm.config_desc') }</p>
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
.opc-ppm {
  .beta-icon {
    border-radius: 100px;
    background: linear-gradient(45deg, #493AB7 0%, #925DFF 100%);
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    padding: 0 6px;
    text-transform: uppercase;
  }
  &.opc-tile {
    padding: 0;
    border-radius: 16px;
    overflow: hidden;
  }
  .flex-container {
    display: flex;
    align-items: center;
  }
  .header-container {
    padding: 24px;
  }
  .main-icon {
    color: $theme-color;
  }
  &__name {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #00031F;
  }
  &__logo {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
  &__link {
    padding: 0;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #0B5CFF;
  }
  &__info {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #00031F;
    margin-right: 13px;
  }
  &__body {
    background: #F7F7F8;
    &-item {
      display: flex;
      padding: 37px 23px 48px 33px;
      justify-content: flex-start;
      flex: 1;
      &-icon {
        margin-top: 5px;
        width: 25px;
        height: 25px;
        margin-right: 6px;
      }
      &-title {
        font-family: Almaden Sans;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #00053D;
      }
      &-text {
        font-family: Almaden Sans;
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0.01em;
        text-align: left;
        color: #515079;
      }
    }
  }
}
</style>
